import {MouseEventHandler} from 'react';

import {ActionStyle, ActionType} from 'components/design-guide';
import Action from 'components/design-guide/Action';
import {ActionStyleButton} from 'components/design-guide/Action/Button/types';
import {ActionStyleStyledIcon, ActionStyleText} from 'components/design-guide/Action/Hyperlink/types';
import {GLOBAL_PHONE_NUMBERS} from 'shared/IntlFormatMessage/translations/globalTranslations';
import {intlFormatSingleMessage} from 'shared/IntlFormatMessage/utils/intlMesssageFormat';
import {MarginProps} from 'utils/components';

interface Props {
  styleProps: ActionStyleText | ActionStyleButton | ActionStyleStyledIcon;
  name: string;
  phoneNumber?: string;
  margin?: MarginProps;
  beforeNavigation?: MouseEventHandler<HTMLAnchorElement>;
}

const PhoneNumberAction = ({
  styleProps,
  phoneNumber = GLOBAL_PHONE_NUMBERS.CONTACT_PHONE_INTL,
  name,
  beforeNavigation,
  margin
}: Props) => (
  <Action
    {...{name, margin}}
    {...styleProps}
    actionType={ActionType.PHONE}
    typeProps={{phoneNumber, beforeNavigation}}
    aria-label={`Call ${phoneNumber}`}
  />
);

export const BasicInlinePhoneNumberLink = () => (
  <PhoneNumberAction
    styleProps={{
      actionStyle: ActionStyle.INLINE_TEXT,
      children: intlFormatSingleMessage(GLOBAL_PHONE_NUMBERS.CONTACT_PHONE_DISPLAY, {withCall: false})
    }}
    name="amica-contact-phone-link"
  />
);

export const QuotingInlinePhoneNumberLink = ({
  phoneIntl = GLOBAL_PHONE_NUMBERS.CONTACT_QUOTE_PHONE_DISPLAY,
  formattedPhoneIntl = GLOBAL_PHONE_NUMBERS.CONTACT_QUOTE_PHONE_INTL
}: {
  phoneIntl?: string;
  formattedPhoneIntl?: string;
}) => (
  <PhoneNumberAction
    phoneNumber={intlFormatSingleMessage(formattedPhoneIntl)}
    styleProps={{
      actionStyle: ActionStyle.INLINE_TEXT,
      children: intlFormatSingleMessage(phoneIntl, {
        withCall: false
      })
    }}
    name="amica-contact-phone-link"
  />
);

export default PhoneNumberAction;
